import React from 'react';
import LayoutSimple from '../components/layout/LayoutSimple';
import { motion } from 'framer-motion';

const PrivacyPolicy = () => {
  return (
    <LayoutSimple>
      <div className="max-w-4xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="bg-white shadow-xl rounded-2xl p-8 md:p-12 border border-blue-50"
        >
          <h1 className="text-4xl font-extrabold text-slate-900 mb-8 border-b pb-4">Privacy Policy</h1>
          
          <div className="space-y-6 text-slate-600 leading-relaxed">
            <section>
              <h2 className="text-xl font-bold text-slate-800 mb-3">1. Information Collection</h2>
              <p>We collect information you provide directly to us, including company details, user names, email addresses, and any business data (leads/customers) you manage through our CRM.</p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-slate-800 mb-3">2. How We Use Your Data</h2>
              <p>Your data is used solely to provide and improve the CRM services, facilitate communication, and ensure the security of your account. We do not sell your data to third parties.</p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-slate-800 mb-3">3. Data Security</h2>
              <p>We implement industry-standard security measures, including encryption and secure socket layers (SSL), to protect your data. However, no method of transmission over the internet is 100% secure.</p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-slate-800 mb-3">4. Third-Party Services</h2>
              <p>We may use third-party providers for hosting, analytics, and payment processing. These providers have access to your info only to perform tasks on our behalf and are obligated not to disclose or use it for other purposes.</p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-slate-800 mb-3">5. Your Rights</h2>
              <p>You have the right to access, update, or delete your personal information at any time through your account settings or by contacting our support team.</p>
            </section>

            <p className="text-sm pt-8 border-t text-slate-400">Last updated: April 2026</p>
          </div>
        </motion.div>
      </div>
    </LayoutSimple>
  );
};

export default PrivacyPolicy;
